import 'scss/solutions/entertainment-voice-solution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'
import { player } from 'js/libs/jplayer/init-audio'
$(function () {
  $('.audio-btn').click(function () {
    if ($(this).hasClass('playing')) {
      player.pause()
    } else {
      var type = $(this).data('type')
      var url = `//cdn.aidaxue.com/yinpin20181219/${type}`
      var $this = $(this)
      player.buttonClick({
        wav: `${url}.wav`,
        mp3: `${url}.mp3`
      }, null, function () {
        $('.audio-btn').removeClass('playing')
        $this.addClass('playing')
      }, function () {
        $this.removeClass('playing')
      })
    }
  })
  $('.audio-play').click(function () {
    if ($(this).hasClass('playing')) {
      player.pause()
    } else {
      var type = $(this).data('type')
      var url = `//cdn.aidaxue.com/yinpin20181221/${type}`
      var $this = $(this)
      player.buttonClick({
        wav: `${url}.wav`,
        mp3: `${url}.mp3`
      }, null, function () {
        $('.audio-play').removeClass('playing')
        $this.addClass('playing')
      }, function () {
        $this.removeClass('playing')
      })
    }
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/entertainment-voice-solution.js